import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/query-client';
import { ThemeProvider } from './contexts/ThemeContext';
import { BreadcrumbOverrideProvider } from './contexts/BreadcrumbOverrideContext';
import { AppRoutes } from './routes';
import { AnalyticsManager } from './components/AnalyticsManager';
import { ErrorBoundary } from './components/common/error-boundary';
import { LanguageGate } from './components/LanguageGate';
import { DevTools } from './components/DevTools';
import { Toaster } from './components/ui/toaster';
import { SessionKeepalive } from './components/SessionKeepalive';
import { TooltipProvider } from './components/ui/tooltip';

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <LanguageGate>
          <ThemeProvider>
            <TooltipProvider delayDuration={300}>
              <BrowserRouter>
                <BreadcrumbOverrideProvider>
                  <Suspense
                    fallback={
                      <div className="flex h-screen items-center justify-center">
                        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
                      </div>
                    }
                  >
                    <AppRoutes />
                    <SessionKeepalive />
                    <AnalyticsManager />
                    <DevTools />
                    <Toaster />
                  </Suspense>
                </BreadcrumbOverrideProvider>
              </BrowserRouter>
            </TooltipProvider>
          </ThemeProvider>
        </LanguageGate>
      </QueryClientProvider>
    </ErrorBoundary>
  );
};

export default App;
